import { makeStyles } from 'hooks';

export default makeStyles(theme => ({
  titleSectionBody: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.getContrastText(theme.palette.primary.dark),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    marginBottom: theme.spacing(4),
    '@media print': {
      display: 'none'
    }
  },
  titleSectionTitle: {
    fontFamily: "'JakartaDisplay', sans-serif",
    fontWeight: 500,
    lineHeight: 1.3
  },
  titleSectionDescription: {
    fontFamily: "'JakartaDisplay', sans-serif",
    fontWeight: 400,
    color: theme.isBranded ? undefined : '#eeb0ff'
  },
  withTabs: {
    paddingBottom: '4px !important'
  },
  container: {
    position: 'relative'
  },
  helpButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    fontSize: 16
  },
  helpText: {
    [theme.breakpoints.only('xs')]: {
      display: 'none'
    }
  },
  helpButtonIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  fabBase: {
    position: 'absolute',
    top: theme.spacing(-7.5),
    left: `calc(50% - ${theme.spacing(3.5)}px)`,
    transition: theme.transitions.create('top', { duration: theme.transitions.duration.complex })
  },
  fabNotCollapsed: {
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(2)
  },
  fabEmptyContainer: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(4),
    maxWidth: theme.spacing(40)
  },
  itemFabContainer: {
    display: 'flex',
    textAlign: 'center'
  },
  itemFabEmptyContainer: {
    maxWidth: theme.spacing(40),
    margin: '0 auto',
    paddingTop: theme.spacing(2)
  },
  pageFabTooltip: {
    // page fab often uses dropdown, so make sure tooltip will go under that
    zIndex: theme.zIndex.modal - 1
  }
}));